import React, { FC, memo } from 'react';
import ReactPaginate from 'react-paginate';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { AppPaginationCompact } from 'components/app-pagination-compact';
import { useIsBelowMd } from 'hooks/use-is-below-md';

const Pager: FC<
  React.PropsWithChildren<{
    pagination: any;
    onTasks: any;
  }>
> = ({ pagination, onTasks }) => {
  const isBelowMd = useIsBelowMd();
  if (!pagination || isNaN(pagination.total) || pagination.total < 2) return null;
  // N3 (T3, D-130): below md the compact pager -- the page numbers wrapped
  if (isBelowMd) {
    return (
      <AppPaginationCompact
        page={pagination.page}
        pages={pagination.total}
        onChange={(page) => onTasks([['pagination', { page }], ['getData']])}
      />
    );
  }
  return (
    <ReactPaginate
      forcePage={pagination.page - 1}
      previousLabel={<KeyboardArrowLeftIcon />}
      nextLabel={<KeyboardArrowRightIcon />}
      breakLabel={'...'}
      breakClassName={'break-me'}
      pageCount={pagination.total}
      marginPagesDisplayed={1}
      pageRangeDisplayed={4}
      disableInitialCallback={true}
      onPageChange={(e: any) => onTasks([['pagination', { page: e.selected + 1 }], ['getData']])}
      containerClassName={'pagination'}
      activeClassName={'active'}
    />
  );
};

export default memo(Pager);
